<script>
import AdminLayout from '@layouts/admin-main'
import ClientList from '@components/admin/oauth2-client-list'
import MemberNav from '@components/admin/member-nav'

export default {
  page: {
    title: 'Admin::MemberOauth2ClientList',
    meta: [{ name: 'description', content: 'Admin::MemberOauth2ClientList' }],
  },
  components: { AdminLayout, ClientList, MemberNav },
}
</script>

<template>
  <AdminLayout>
    <MemberNav></MemberNav>
    <ClientList></ClientList>
  </AdminLayout>
</template>
